<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to="/Solution">
        <img class="backPic" src="../../static/images/back.png" />
      </router-link>
      <div class="container">
        <img
          class="solutionDetailTitle1"
          src="../../static/images/solutionText12.png"
        />
        <br />
        <img
          class="solutionDetailTitle2"
          src="../../static/images/solutionText13.png"
        />
        <div class="solutionDetailText">
          利用物联网、大数据、IT服务化平台等技术，结合业界的数字化转型领先实践经验，在物流领域开展物流对象过程数字化、资源规划智能化、流程可视化等方面的建设，构建多位一体全透明自动化物流体系，从生产到运输的全生命周期的流程可视，真正做到“人与物的高效沟通”。
        </div>
        <div class="solutionDetailFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">智慧物流调度管理平台</div>
            <div class="solutionDetailSecondText">
              智慧物流调度管理平台主要服务于具有物流运输业务的企业，利用平台具备的先进的大数据、人工智能等技术，为其构建“物流运营智慧大脑”，可在短时间内按需设定成本低、时效优、负载佳等优化目标，实现订单预测、配送路径优化、车辆调度及智能排班等功能。其中该平台具备先进的自主研发的智能优化算法，能够有效提高工作效率，为企业提高资源利用率，降低运营成本。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic20.jpg"
            />
          </div>
        </div>

        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic21.jpg"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">应用场景</div>
            <div class="solutionDetailSecondText">
              城市配送：社会经济的高速发展对现代物流运输配送提出了更高的要求，人工决策无法满足时效性高、资源利用率高、成本低等运输要求。通过多种人工智能算法自动匹配城市配送实现业务场景需求，支持多维度的配送约束条件，客户自主选择优化目标，实现城市配送的高效智能化运作，降低运输成本，提高车辆周转率。目前已应用至6大行业：零售商超、食品生鲜、生产企业、快递配送、贵重物品押运、危险品运输。
            </div>
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">应用场景</div>
            <div class="solutionDetailSecondText">
              航空物流：航空物流企业在面对供需失衡、竞争日益激烈的市场环境时，为提高自身的获客能力，需不断提高派送网络和全链条服务的竞争优势。北斗智慧物流通过智能算法模型，以及人工智能、大数据等技术的应用，快速对客户的需求进行计划、分单、资源匹配并派单执行，为客户提供优质的航空货运服务。
            </div>
          </div>
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic22.jpg"
            />
          </div>
        </div>
        <div class="solutionDetailThirdFlex">
          <div class="solutionDetailItem">
            <img
              class="solutionDetailPic"
              src="../../static/images/solutionDetailPic23.jpg"
            />
          </div>
          <div class="solutionDetailItem">
            <div class="solutionDetailSecondTitle">票价生成软件</div>
            <div class="solutionDetailSecondText">
              港口物流：港口码头作为港口物流必经据点，其效率是港口竞争力的重要指标之一。北斗智慧物流对码头设备进行数据质量分析，解决设备位置可视化问题，智能调度码头资源。监控外部车辆，提前为外部车辆预留、调配码头资源，加快码头运转；管理调度内部车辆与设备，通过分析场区内道路状况、道路运行车辆空重比、驾驶员路径选择习惯等进行道路运行状态感知，实现最优路径的指引导航；合理进行码头资源分配，提高设备利用率，减少运作成本；安全监管设备数据，统计分析，打破瓶颈，实现港口码头运作效率和效益的提升。
            </div>
          </div>
        </div>
      </div>
      <div class="bottomFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>


<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  components: {
    Foot,
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  methods: {},
};
</script>
<style scoped>
@import "./solutionDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/SolutionDetail6.vue